export const apiKeyMap = "AIzaSyDzdU_FFQ9kESl50PBGCZLzVMvK4biAVqY";
